import { TemplateType } from '~/types/template';

export const SUPPORT_FETCH_ASSET_TEMPLATE_ASSIGNED = [
  TemplateType.ARTICLE,
  TemplateType.PAGE,
  TemplateType.PRODUCT,
  TemplateType.COLLECTION,
];

export const TEMPLATE_TYPE_USED_FOR_FILTER_DEFAULT = [
  TemplateType.PRODUCT,
  TemplateType.COLLECTION,
  TemplateType.HOME,
];
export const THEME_PAGE_ID_ORIGIN = '0';
